import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import "@fontsource/montserrat";
import "@fontsource/outfit";

import MainLayout from './layouts/Main/MainLayout';
import Inicio from './pages/main/Inicio/Inicio';
import Nosotros from './pages/main/Nosotros/Nosotros';
import ActividadesClub from './pages/main/Actividades/Actividades';
import Nivel from './pages/main/Actividades/Nivel/Nivel';
import Contacto from './pages/main/Contacto/Contacto';
import Registro from './pages/main/Registro/Registro';
import DesignSystem from './pages/main/DesignSystem/DesignSystem';
import { ComingSoonPage, ErrorPage, MaintenancePage, NotFoundPage } from './pages/main/Status/StatusPages';
import { AppErrorBoundary, NetworkStatusBoundary } from './pages/main/Status/StatusBoundaries';
import RedirectStatusPage from './pages/main/Status/RedirectStatusPage';

import PerfilLayout from './layouts/Perfil/PerfilLayout';
import InicioPerfil from './pages/perfil/Inicio/InicioPerfil';
import RegistroPerfil from './pages/perfil/Registro/RegistroPerfil';
import EditarRegistroPerfil from './pages/perfil/Registro/EditarRegistroPerfil';
import SocioPerfil from './pages/perfil/Registro/SocioPerfil';
import PagosPerfil from './pages/perfil/Pagos/PagosPerfil';
import FamiliaPerfil from './pages/perfil/Familia/FamiliaPerfil';
import EditarContactoPerfil from './pages/perfil/Familia/EditarContactoPerfil';
import EditarHijoPerfil from './pages/perfil/Familia/EditarHijoPerfil';
import EditarEscolarPerfil from './pages/perfil/Familia/EditarEscolarPerfil';
import OnboardingPerfil from './pages/perfil/Onboarding/OnboardingPerfil';


import DashboardLayout from './layouts/Dashboard/DashboardLayout';
import Dashboard from './pages/dashboard/Dashboard/Dashboard';
import Actividades from './pages/dashboard/Actividades/Actividades';
import ActividadesDetails from './pages/dashboard/Actividades/ActividadesDetails';
import Socios from './pages/dashboard/Socios/Socios';
import SocioDetail from './pages/dashboard/Socios/Details/SocioDetail';
import Instructores from './pages/dashboard/Instructores/Instructores';
import InstructoresDetails from './pages/dashboard/Instructores/Details/InstructoresDetails';
import Fotos from './pages/dashboard/Fotos/Fotos';
import Categorias from './pages/dashboard/Categorias/Categorias';
import CategoriaDetail from './pages/dashboard/Categorias/CategoriaDetail';
import Tags from './pages/dashboard/Tags/Tags';
import TagDetail from './pages/dashboard/Tags/TagDetail';
import Lugares from './pages/dashboard/Lugares/Lugares';
import LugarDetail from './pages/dashboard/Lugares/LugarDetail';
import Calendario from './pages/dashboard/Calendario/Calendario';
import Inventario from './pages/dashboard/Inventario/Inventario';
import Finanzas from './pages/dashboard/Finanzas/Finanzas';
import AjustesClub from './pages/dashboard/Club/Club';
import AjustesNivel from './pages/dashboard/Club/Nivel';
import Accesos from './pages/dashboard/Accesos/Accesos';
import Logs from './pages/dashboard/Logs/Logs';
import CampDashboard from './pages/dashboard/camp/Dashboard/Dashboard';
import CampSocios from './pages/dashboard/camp/Socios/Socios';
import CampInstructores from './pages/dashboard/camp/Instructores/Instructores';
import CampAccesos from './pages/dashboard/camp/Accesos/Accesos';

function App() {
  return (
    <Router>
      <AppErrorBoundary>
        <NetworkStatusBoundary>
          <Routes>
            <Route path="/design-system" element={<DesignSystem />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/mantenimiento" element={<MaintenancePage />} />
            <Route path="/proximamente" element={<ComingSoonPage />} />

        {/* Routes with MainLayout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Inicio />} />
          
          
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/actividades" element={<ActividadesClub />} />
          <Route path="/actividades/:id" element={<Nivel />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/camp" element={<ComingSoonPage embedded />} />
          
          
          <Route path="/registro" element={<Registro />} />
        </Route>

        {/* Routes with PerfilLayout */}
        <Route element={<PerfilLayout />}>
          <Route path="/perfil" element={<InicioPerfil />} />
          <Route path="/perfil/onboarding" element={<OnboardingPerfil />} />
          <Route path="/perfil/registro" element={<RegistroPerfil />} />
          <Route path="/perfil/registro/:socioId" element={<SocioPerfil />} />
          <Route path="/perfil/registro/:socioId/:programa" element={<EditarRegistroPerfil />} />
          <Route path="/perfil/familia" element={<FamiliaPerfil />} />
          <Route path="/perfil/familia/contacto/:tipo" element={<EditarContactoPerfil />} />
          <Route path="/perfil/familia/escolar" element={<EditarEscolarPerfil />} />
          <Route path="/perfil/familia/hijos/:hijoId" element={<EditarHijoPerfil />} />
          <Route path="/perfil/pagos" element={<PagosPerfil />} />
          <Route path="/perfil/hijos" element={<RedirectStatusPage to="/perfil/familia" title="Tus hijos ahora están en Familia" description="Reorganizamos esta sección para que toda la información familiar esté en un solo lugar." />} />
          <Route path="/perfil/padres" element={<RedirectStatusPage to="/perfil/familia" title="Los contactos ahora están en Familia" description="Reorganizamos esta sección para que toda la información familiar esté en un solo lugar." />} />
        </Route>

        {/* Routes with DashboardLayout */}
        <Route path="/dashboard" element={<RedirectStatusPage to="/dashboard/club" eyebrow="Seleccionando portal" title="Preparando tu dashboard" description="Te llevaremos al portal principal para comprobar tu acceso." />} />

        <Route path="/dashboard/club" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="actividades" element={<Actividades />} />
          <Route path="actividades/:id" element={<ActividadesDetails />} />
          <Route path="socios" element={<Socios />} />
          <Route path="socios/:id" element={<SocioDetail />} />
          <Route path="instructores" element={<Instructores />} />
          <Route path="instructores/:id" element={<InstructoresDetails />} />
          <Route path="fotos" element={<Fotos />} />
          <Route path="categorias" element={<Categorias />} />
          <Route path="categorias/:id" element={<CategoriaDetail />} />
          <Route path="tags" element={<Tags />} />
          <Route path="tags/:id" element={<TagDetail />} />
          <Route path="lugares" element={<Lugares />} />
          <Route path="lugares/:id" element={<LugarDetail />} />
          <Route path="calendario" element={<Calendario />} />
          <Route path="inventario" element={<Inventario />} />
          <Route path="finanzas" element={<Finanzas />} />
          <Route path="club" element={<AjustesClub />} />
          <Route path="club/:id" element={<AjustesNivel />} />
          <Route path="accesos" element={<Accesos />} />
          <Route path="logs" element={<Logs />} />
        </Route>

        <Route path="/dashboard/camp" element={<DashboardLayout />}>
          <Route index element={<CampDashboard />} />
          <Route path="socios" element={<CampSocios />} />
          <Route path="instructores" element={<CampInstructores />} />
          <Route path="accesos" element={<CampAccesos />} />
        </Route>

        <Route path="/dashboard/*" element={<NotFoundPage />} />
        
         
          <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </NetworkStatusBoundary>
      </AppErrorBoundary>
    </Router>

  );
}

export default App;
